import { getToken } from '../../session';
import type { CarrierZoneEntries } from './types';
import getGatewayUri from '../getGatewayUri';
import axios from 'axios';

export class ZipZoneService {
  public async fetchZipZoneMappings(
    carrier: string,
    zoneKeyType: string,
    countryCode: string,
    carrierServiceMethod?: string,
    originPostalCode?: string,
  ): Promise<CarrierZoneEntries> {
    const res = await axios({
      method: 'GET',
      baseURL: getGatewayUri(),
      url: `/sim-carrier-proxy/api/v2/carriers/${carrier}/zones/${countryCode}`,
      withCredentials: true,
      params: {
        zoneKeyType: zoneKeyType,
        originCountryCode: countryCode,
        carrierId: carrier,
        originPostalCode: originPostalCode,
        carrierServiceMethod: carrierServiceMethod,
      },
      headers: {
        authorization: `Bearer ${getToken()}`,
      },
      responseType: 'json',
    });
    return res.data;
  }
}
